module.exports = __webpack_public_path__ + "img/Caret-Up_Filled_16px_Grey_Icon.d0a9fdd1.svg";